import { useQuery } from '@tanstack/react-query';
import { ApiConfig } from '@/config/api.config';
import { UrlHelper } from '@/utils/UrlHelper';
import { useAxiosAuth } from '@/hooks/useAxiosAuth';
import { TenantListResponseDto } from '@/features/superAdmin/features/tenants/types/superAdmin-tenants-dto';

const SELECT_OPTIONS_TAKE = 5000;

export const useTenantsSelectOptionsApi = () => {
	const axiosInstance = useAxiosAuth();

	const {
		data: tenantsSelectData,
		isLoading: isLoadingTenantsSelect,
		isError: isErrorTenantsSelect,
	} = useQuery({
		queryKey: [ApiConfig.queries.superAdmin.tenants.queryKeys.selectOptions],
		queryFn: async (): Promise<TenantListResponseDto> => {
			const url = UrlHelper.buildUrlWithQueryParams(
				ApiConfig.queries.superAdmin.tenants.endpoints.list,
				{
					take: SELECT_OPTIONS_TAKE,
					skip: 0,
				},
			);
			const response = await axiosInstance.get<TenantListResponseDto>(url);
			return response.data;
		},
	});

	return {
		tenantsSelectData,
		isLoadingTenantsSelect,
		isErrorTenantsSelect,
	};
};
